module.exports = __webpack_public_path__ + "img/licence-certificate.be5a5c18.jpg";